<div class="the_container">
  @if(!isMobileDevice){
  <div class="heading-div d-flex justify-content-between">
    <div class="d-flex gap-2">
      @if(reachAccess){
      <span class="heading-text">Reach Defaulter</span>
      }@else{
      <span class="heading-text">Defaulter List</span>
      }
      @if(lastRefreshedDate){
      <span class="heading-text">(Last Refreshed Date - {{lastRefreshedDate}})</span>
      }
    </div>
    @if(reachAccess){
    <button class="button-div dp-primary-btn" (click)="onWishlistClick('centralizedReach', '')">
      <span class="button-text">My Wishlists</span>
      <img src="../../assets/images/heart-line.svg" /></button>}
  </div>
  }
  <!-- <app-dp-tab-menu></app-dp-tab-menu> -->
  <app-dp-tab-menu-v3></app-dp-tab-menu-v3>

  <router-outlet></router-outlet>
</div>